import { Tag } from '@cian/components';
import * as React from 'react';

import { IOfferIdTag } from '../../../state/tags/definitions/offer_id';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IOfferIdTagItemProps {
  tag: IOfferIdTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const OfferIdTagItem = ({ onDeleteClick, tag, withNewTag }: IOfferIdTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Объявление №{tag.value}
    </TagComponent>
  );
};
